const key = 'cabmun-gratitudes';
type GratitudesProps = { lastVisited: number | null };

const defaultGratitudesProps: GratitudesProps = { lastVisited: null };

export function set(params: GratitudesProps) {
  const getted = get();
  localStorage.setItem(key, JSON.stringify({ ...getted, ...params }));
}

export function get(): GratitudesProps {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : defaultGratitudesProps;
}
